import { ETypographySize } from "@/3514/components"
import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { EInputVariant } from "./input.types"

const _sharedDefaultClasses: string = buildCssClassName(
    "!outline-[0px]",
    "!outline-transparent",
    "selection:bg-blue-400",
    "text-gray-200",
    "hover:bg-white",
    "hover:border-blue-300",
    "focus:bg-white",
    "focus:border-blue-300"
)

const _sharedDisabledClasses: string =
    "!outline-[0px] !outline-transparent cursor-not-allowed border-blue-500 bg-white text-gray-200"

const _sharedErrorClasses: string =
    "!outline-[0px] !outline-transparent selection:bg-red-400 border-red-200 text-gray-100"

export default {
    colors: {
        [EInputVariant.Whitish]: {
            default: ({ isFilled }: { isFilled: boolean }): string =>
                buildCssClassName(_sharedDefaultClasses, [
                    isFilled ? "bg-white border-blue-500" : "bg-blue-600 border-transparent"
                ]),
            disabled: (_params: object): string => _sharedDisabledClasses,
            error: (_params: object): string => _sharedErrorClasses
        },
        [EInputVariant.White]: {
            default: (_params: object): string => buildCssClassName(_sharedDefaultClasses, "bg-white border-blue-400"),
            disabled: (_params: object): string => _sharedDefaultClasses,
            error: (_params: object): string => _sharedErrorClasses
        }
    },
    classes: {
        container: (): string => "flex flex-col gap-y-[5px] relative",
        wrapper: ({ isColumn }: { isColumn: boolean }): string =>
            buildCssClassName("flex justify-start", {
                "flex-col items-start": isColumn,
                "flex-row items-center gap-x-[5px]": !isColumn
            }),
        label: ({ isVisible }: { isVisible: boolean }): string =>
            buildCssClassName(
                isVisible
                    ? [
                          "block",
                          "mb-0",
                          "text-gray-100",
                          "text-[12px]",
                          "md:text-[14px]",
                          "leading-[18px]",
                          "md:leading-[21px]",
                          "font-[300]"
                      ]
                    : "hidden"
            ),
        input: ({ textSize }: { textSize: ETypographySize }): string =>
            buildCssClassName(
                "w-full",
                "px-[15px]",
                "py-[10px]",
                "caret-gray-100",
                "rounded-[8px]",
                "border-[1px]",
                "font-[300]",
                "autofill:[box-shadow:0_0_0_1000px_#F8F8FE_inset]",
                "placeholder:text-gray-300",
                "placeholder:font-[300]",
                {
                    "text-[16px] leading-[24px] placeholder:text-[16px] placeholder:leading-[24px]":
                        textSize === ETypographySize.Medium
                },
                {
                    "text-[14px] leading-[21px] placeholder:text-[14px] placeholder:leading-[21px]":
                        textSize === ETypographySize.Small
                },
                getTransitionTwClasses("all", 200)
            ),
        icon: (): string => "[pointer-events:none] absolute translate-y-1/2 right-[20px] bottom-[50%]"
    }
}
